import * as React from 'react';

import { MyHomeHomownerTrap } from 'shared/components/MyHomeTrap/MyHomeHomownerTrap/MyHomeHomownerTrap';
import { useAddToMyHomeObject } from 'shared/containers/valuationTraps/hook/useAddToMyHomeObject';
import { useCloseMyHomeHomeownerTrap } from 'shared/containers/valuationTraps/hook/useCloseMyHomeHomeownerTrap';

export const MyHomeHomeownerTrapContainer: React.FC = () => {
  const { handleClick } = useAddToMyHomeObject();
  const { isClose, handleClose } = useCloseMyHomeHomeownerTrap();

  if (isClose) {
    return null;
  }

  return <MyHomeHomownerTrap onClick={handleClick} onClose={handleClose} />;
};
